export const config = {
  apiBaseUrl: import.meta.env.DEV
    ? (import.meta.env.VITE_API_BASE_URL ?? "http://localhost:4300")
    : "",
} as const;
